import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { uniqueId } from 'lodash';

import styles from '../../containers/StewardAssetEditPage/StewardAssetEditPage.scss';

const propTypes = {
  id: PropTypes.string,
  label: PropTypes.string,
  field: PropTypes.string,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  readOnly: PropTypes.bool,
  validation: PropTypes.arrayOf(PropTypes.string),
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  fullWidth: PropTypes.bool,
  onChange: PropTypes.func.isRequired
};

const defaultProps = {
  id: null,
  value: '',
  disabled: false,
  readOnly: false,
  validation: []
};

export default class TextInput extends PureComponent {
  render() {
    const id = this.props.id || `${uniqueId('text-')}_${this.props.field.replace('.', '_')}`;
    const label = !this.props.label ? null : (
      <label htmlFor={id}>{this.props.label}</label>
    );
    const validation = !this.props.validation ? null : (
      <ul>{this.props.validation.map((err) => (
        <li key={err}>{err}</li>
      ))}
      </ul>
    );
    const validationCSS = this.props.validation.length > 0 ? styles["validation-problems"] : "";
    const requiredCSS = this.props.required ? styles.required : "";
    const fullWidthCSS = this.props.fullWidth ? styles["full-width"] : "";
    const css = `${styles["text-input"]} ${requiredCSS} ${fullWidthCSS} ${validationCSS}`;
    const { value, field, disabled, readOnly, onChange } = this.props;
    return (
      <div className={css}>
        {label}
        <input
          id={id}
          data-field={field}
          value={value}
          disabled={disabled}
          readOnly={readOnly}
          onChange={onChange} />
        {validation}
      </div>
    );
  }
}

TextInput.propTypes = propTypes;
TextInput.defaultProps = defaultProps;
